import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import Column from "../components/MainMenuDropdown/components/Column";
import MainMenuLink from "../components/MainMenuDropdown/components/MainMenuLink";
import MainMenuDropdown from "../components/MainMenuDropdown";
import Footer from "../components/MainMenuDropdown/components/Footer";
import FooterLink from "../components/MainMenuDropdown/components/FooterLink";

import { useStore } from "../../../connect";

import strings from "../../../locales/strings";

const isGuaranteePaymentNew = new Date("2025-03-07T00:00:00.000Z") > new Date();
const isCourierNew = new Date("2025-12-06T00:00:00.000Z") > new Date();

const CarriersDropdown = ({ isMobile }) => {
  const { profile } = useStore();
  const { shouldRedirectBoardsToLoads } = profile.counters;

  return (
    <MainMenuDropdown
      isMobile={isMobile}
      footer={
        <Footer type="carriers" isMobile={isMobile}>
          <FooterLink name="add-truck-new" />
          <FooterLink name="add-order" />
        </Footer>
      }
    >
      <Column title={strings.menu_section_trucksAndOrders}>
        <MainMenuLink
          name="your-trucks"
          isCounterActive={!!profile.counters.trucksActions}
          counter={profile.counters.yourTrucks}
        />
        <MainMenuLink
          name="orders-to-you"
          isCounterActive
          counter={profile.counters.ordersToYou}
        />
        <MainMenuLink name="gps" />
        <MainMenuLink
          name="boards"
          isCounterActive={!!profile.counters.isBoardsActive}
          counter={profile.counters.boards}
        />
      </Column>
      <Column title={strings.menu_section_loadsSearch}>
        <MainMenuLink name="loads-search" />
        <MainMenuLink name="cargo-chains" />
        {shouldRedirectBoardsToLoads ? (
          <MainMenuLink name="boards-search-redirect" />
        ) : (
          <MainMenuLink name="boards-search" />
        )}
        <MainMenuLink name="tenders" />
      </Column>
      <Column title={strings.menu_section_usefull}>
        <MainMenuLink name="courier" isNew={isCourierNew} />
        <MainMenuLink
          name="menu-guarantee-payment"
          isNew={isGuaranteePaymentNew}
        />
        <MainMenuLink name="rating-for-carriers" />
        <MainMenuLink
          name="catalogs"
          isCounterActive
          counter={profile.counters.autopark}
        />
        <MainMenuLink name="carriers-reports" />
        <MainMenuLink name="checks" />
        {/* <MainMenuLink name="safety-memo" /> */}
      </Column>
    </MainMenuDropdown>
  );
};

CarriersDropdown.propTypes = {
  isMobile: PropTypes.bool,
};

export default observer(CarriersDropdown);
